<template>
    <div>
		<template v-if="attendance_report === true">
			<div class="page-top mb-1 mb-3 clearfix">
				<h1 class="mt-0"> Attendance Report </h1>
			</div>
            <div class="peopple-managment-main">
                <div class="people-management-inner-content pt-5 pb-0 pl-5 pr-5">
                    <div class="row">
                        <div class="col-md-12">
                            <div class="form-group">
                                <label class="label block-label">Select Report Type</label>
                            </div>
                        </div>
                        <div class="col-md-4">
                            <div class="form-group">
                                <label class="label block-label"> Individual </label>
                                <label class="radio-holder">
                                    <input type="radio" name="individual" v-model="type" value="individual"/>
                                    <span class="checkmark"></span>
                                </label>
                            </div>
                        </div>
                        <div class="col-md-4">
                            <div class="form-group">
                                <label class="label block-label"> Departments </label>
                                <label class="radio-holder">
                                    <input type="radio" name="departments" v-model="type" value="departments"/>
                                    <span class="checkmark"></span>
                                </label>
                            </div>
                        </div>
                        <div class="col-md-4">
                            <div class="form-group">
                                <label class="label block-label"> Teams </label>
                                <label class="radio-holder">
                                    <input type="radio" name="teams" v-model="type" value="teams"/>
                                    <span class="checkmark"></span>
                                </label>
                            </div>
                        </div>
                    </div>
					<div class="row">
						<div class="col-md-5" v-show="type == 'individual'">
                            <div class="form-group">
                                <label class="label block-label"> Users </label>
                                <select v-model="selected_users" name="selected_users[]" data-live-search="true" class="form-control selectpicker custom-select2" multiple>
                                    <option v-for="(user,index) in users" :value="user.id">{{user.name}}</option>
                                </select>
                            </div>
                        </div>
                        <div class="col-md-5"  v-show="type == 'departments'">
                            <div class="form-group">
                                <label class="label block-label"> Departments </label>
                                <select v-model="selected_departments" name="selected_departments[]" data-live-search="true" class="form-control selectpicker custom-select2" multiple>
                                    <option v-for="(dep,index) in departments" :value="dep.id">{{dep.name}}</option>
                                </select>
                            </div>
                        </div>
                        <div class="col-md-5"  v-show="type == 'teams'">
                            <div class="form-group">
                                <label class="label block-label"> Teams </label>
                                <select v-model="selected_teams" name="selected_teams[]" data-live-search="true" class="form-control selectpicker custom-select2" multiple>
                                    <option v-for="(team,index) in teams" :value="team.id">{{team.name}}</option>
                                </select>
                            </div>
                        </div>
						<div class="col-md-5">
                            <div class="form-group">
                                <label class="label block-label"> From Date </label>
                                <datepicker name="from_date"  v-model="from_date" input-class="datepicker" :bootstrap-styling="true" placeholder="From Date"></datepicker>
                            </div>
                        </div>
                        <div class="col-md-5">
                            <div class="form-group">
                                <label class="label block-label"> To Date </label>
                                <datepicker name="to_date" v-model="to_date" input-class="datepicker" :bootstrap-styling="true" placeholder="To Date"></datepicker>
                            </div>
                        </div>
						<div class="col-md-2">
							<div class="form-group">
                                <br>
								<button @click="exportReport" class="btn btn-primary">Search</button>
							</div>
						</div>
					</div>
				</div>
			</div>
            <div class="tab-content" id="myTabContent">
                <div v-show="hasPer" class="tab-pane fade show active" id="new" role="tabpanel" aria-labelledby="new-tab">
                    <div class="empty-main">
                        <div class="empty-inner">
                            <img src="/images/new_empty_payments.png" alt="" />
                            <h2> Hi, {{user}}! </h2>
                            <p> Select your requirements and export your desired report </p>
                        </div>
                    </div>
                </div>
            </div>
        </template>
        <template v-else-if="attendance_report === null">
            <preLoader></preLoader>
        </template>
        <template v-else-if="attendance_report === false">
            <notAllowed></notAllowed>
        </template>

    </div>
</template>

<script>
	var dtTable = null;
    export default {
        data() {
            return {
				from_date : new Date(),
				to_date : new Date(),
				hasPer : true,
				user : '',
				attendance_report: null,
				export_attendance_report: null,
				selected_users:[],
                selected_departments:[],
                selected_teams:[],
                users: [],
                departments:[],
                teams:[],
                type:'individual'

            };
        },
        mounted() {
            this.$Progress.start();
			this.can('attendance_report').then(result => {
                this.attendance_report = result.attendance_report;
                this.user = result.user_name;
            	this.$Progress.finish();
			}).then(result => {
				this.getUsers();
			});
        },
        methods: {
			getUsers(){
				this.$Progress.start();
                axios.get('/api/getUsers')
                .then(res => {
                    if(res.status == 200){
						this.users = res.data.users;
                        this.departments = res.data.departments;
                        this.teams = res.data.teams;
                        this.$Progress.finish();
                    }else{
                        this.$Progress.fail();
                        this.showAlertBox('error','Some error in your form data');
                    }
                }).then(res => {
                    $(this.$el).find('.selectpicker').selectpicker('refresh');
                })
                .catch(err => {
                    $(this.$el).find('.selectpicker').selectpicker('refresh');
                    this.showAlertBox('error','Some error in your form data');
                });
			},

			exportReport: function(){
				this.$Progress.start();
				var formData = {
					'to_date': moment(this.to_date).format('YYYY-MM-DD'),
					'from_date': moment(this.from_date).format('YYYY-MM-DD'),
					'selected_users':this.selected_users,
                    'selected_teams':this.selected_teams,
                    'selected_departments':this.selected_departments,
                    'type':this.type
                }
                axios.post('/api/employee_attendance_report', formData,{
					responseType: 'blob'
				})
				.then(res => {
					if(res.status == 200){
						const url = URL.createObjectURL(new Blob([res.data], {
						type: 'application/vnd.ms-excel'
					}))

					const link = document.createElement('a')
					link.href = url
					link.setAttribute('download', 'employeeAttendanceReport.xlsx')
					document.body.appendChild(link)
					link.click();
					this.showToastBox('success','Attendance report successfully downloaded');
					this.$Progress.finish();
					}else{
						this.$Progress.fail();
						this.showAlertBox('error','Error to load form data');
					}
				})
				.catch(err => {
					this.$Progress.fail();
					this.showAlertBox('error','Error to load form data');
				});
			}
        },

    }
</script>
